<template>
    <div class="flex flex-col -mt-4">
        <div class="flex mb-1">
            <el-checkbox v-model="model.WidgetTime.is_calendrical" :true-label="1" :false-label="0">
                <span class="main-text-color">{{ $t('widget.config.isCalendrical') }}</span>
            </el-checkbox>
        </div>
        <div class="flex">
            <span class="period-select">
                <label class="main-text-color">{{$t('widget.config.periodType')}}</label>
                <el-select
                    v-model="model.WidgetTime.period_type"
                    placeholder="Select"
                    class="pt-2 w-full"
                    @change="onChangeSelect"
                >
                    <el-option
                        v-for="(item, index) of widgetTimeOptionsForPeriod"
                        :key="index"
                        :label="$t(item.label)"
                        :value="item.value">
                    </el-option>
                </el-select>
            </span>
            <span class="mx-4 flex flex-col">
                <label class="main-text-color">{{ $t('widget.config.periodsBack') }}</label>
                <el-input-number
                    :key="minValForCheckbox"
                    :min="minValForCheckbox"
                    :step="1"
                    :max="maxValue"
                    v-model="model.WidgetTime.periods_back"
                    placeholder="0"
                    class="mt-2"
                    @change="onChangeInput"
                >
                </el-input-number>
            </span>
        </div>
    </div>
</template>
<script>
    import { Option, Select, InputNumber, Checkbox } from 'element-ui'
    import { widgetTimeOptionsForPeriod } from '@/enum/widgetTimeOptions'

    export default {
        components: {
            [Select.name]: Select,
            [Option.name]: Option,
            [InputNumber.name]: InputNumber,
            [Checkbox.name]: Checkbox,
        },
        props: {
            model: {
                type: Object,
                default: () => ({}),
            }
        },
        data () {
            return {
                widgetTimeOptionsForPeriod,
                maxValue: 10,
                minValForCheckbox: null
            }
        },
        mounted() {
            const defaultPeriodType = this.model.WidgetTime.period_type ? this.model.WidgetTime.period_type : this.widgetTimeOptionsForPeriod[0].value
            if (this.model.WidgetTime.periods_back === undefined) {
                const defaultPeriodsBack = this.model.WidgetTime.is_calendrical ? 0 : 1
                this.$set(this.model.WidgetTime, 'periods_back', defaultPeriodsBack)
            }
            this.$set(this.model.WidgetTime, 'period_type', defaultPeriodType)
            this.maxValue = this.widgetTimeOptionsForPeriod.find(el => el.value === this.model.WidgetTime.period_type).max
            this.minValForCheckbox = this.model.WidgetTime.is_calendrical ? 0 : 1
        },
        methods: {
            onChangeSelect (value) {
                this.$set(this.model.WidgetTime, 'period_type', value)
                this.maxValue = this.widgetTimeOptionsForPeriod.find(el => el.value === value).max
                if (this.model.WidgetTime.periods_back > this.maxValue) {
                    this.model.WidgetTime.periods_back = this.maxValue
                }
            },
            onChangeInput (value) {
                this.$set(this.model.WidgetTime, 'periods_back', value)
            }
        },
        watch: {
           'model.WidgetTime.is_calendrical' (val) {
                if (!val) {
                    this.minValForCheckbox = 1
                } else {
                    this.minValForCheckbox = 0
                }
           }
        }
    }
</script>

<style lang="scss" scoped>
.period-select {
    width: 300px;
}
</style>
